import { ViewMode } from '@efdigital/ll-addon-codemirror';
import { debounce } from '@efdigital/ll-addon-ui';
import { MarkdownEditorWithImagePicker } from '@efdigital/ll-admin-v2/components/markdown-editor-with-image-picker';
import { SidebarAll } from '@efdigital/ll-admin-v2/lib/markdown-toolbar';
import { fn } from '@ember/helper';

import { EditRecordCollapse } from '../edit-record-collapse.gts';
import { EditQuizLabelsBase } from './edit-quiz-labels-base.gts';

export class EditQuizInput extends EditQuizLabelsBase {
  setMarkdown = (markdown: string) => {
    this.args.item.markdown = markdown;
  };

  <template>
    <EditRecordCollapse
      @editLabel="Edit Input Presentation"
      @item={{@item}}
      @context={{@context}}
      @maxDepth={{1}}
      @collapseLabel="Input Presentation"
      ...attributes
    >
      <:help>
        <p class="form-text">
          Content displayed to users while they are completing the form.
        </p>
      </:help>
      <:form as |uniqueId isDisabled isReadOnly|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          {{#if isReadOnly}}
            <textarea
              class="form-control font-monospace form-control-small lh-sm mb-3"
              id="{{uniqueId}}-markdown"
              rows="15"
              readonly
            >{{@item.markdown}}</textarea>
          {{else}}
            <div class="mb-3">
              <MarkdownEditorWithImagePicker
                @markdown={{@item.markdown}}
                @toolbar={{SidebarAll}}
                @mode={{ViewMode.EditorOnly}}
                @onUpdate={{this.setMarkdown}}
                @requiredSize="email-image"
              >
                <:preview as |markdown|>
                  <pre>{{markdown}}</pre>
                </:preview>
              </MarkdownEditorWithImagePicker>
            </div>
          {{/if}}

          <div class="mb-3">
            <label for="{{uniqueId}}-submit" class="form-label">
              Submit Button Label
            </label>
            <input
              type="text"
              class="form-control"
              id="{{uniqueId}}-submit"
              value={{this.getLabel "submitButton"}}
              placeholder={{this.getPlaceholder "submitButton"}}
              {{debounce (fn this.setLabel "submitButton")}}
            />
          </div>
        </fieldset>
      </:form>
    </EditRecordCollapse>
  </template>
}
